<!-- Open lots (FIFO). -->
<script lang="ts">
  import type { OpenLotRow } from "../../core/types";
  import { fmtDate, fmtNum, fmtQty } from "../../lib/format";
  import Money from "../../components/Money.svelte";
  import Signed from "../../components/Signed.svelte";
  import Pct from "../../components/Pct.svelte";
  let { lots }: { lots: readonly OpenLotRow[] } = $props();
</script>

{#if !lots.length}
  <p class="muted">Brak otwartych partii.</p>
{:else}
  <div class="table-wrap"><table><thead><tr><th class="l">Nabyte</th><th class="l">Rachunek</th><th class="l">Symbol</th><th>Ilość</th><th>Koszt (waluta)</th><th>Kurs NBP</th><th>Koszt PLN</th><th>Wartość</th><th>Zysk</th><th>%</th><th>Rocznie</th><th>Dni</th><th class="l">Uwagi</th></tr></thead>
    <tbody>
      {#each lots as l, i (i)}
        <tr><td class="l">{fmtDate(l.openDay)}</td><td class="l">{l.account}</td><td class="l">{l.symbol}</td><td>{fmtQty(l.qty)}</td>
          <td><Money v={l.costCur} d={2} ccy={l.costCcy} /></td><td>{fmtNum(l.fxOpen, 4)}</td><td><Money v={l.costPLN} d={2} /></td><td><Money v={l.value} /></td><td><Signed v={l.value - l.costPLN} /></td><td><Pct v={l.ret} /></td><td><Pct v={l.ann} /></td><td>{l.days}</td>
          <td class="l small muted">{l.transferredFrom ? `przeniesione z ${l.transferredFrom} (${l.buySymbol})` : l.external ? "przyjęte z zewnątrz" : ""}</td></tr>
      {/each}
    </tbody>
  </table></div>
{/if}
